import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { Coverage } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface PutCoveragesParams extends DefaultHttpHeaders {
  projectQuoteId: string;
  riskId: string;
  companyId?: string;
  version: string;
}

@Injectable()
export class PutCoveragesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Update project coverages
   * Update project coverages
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Project/putProjectCoverages
   */
  putCoverages(body: Coverage[], params: PutCoveragesParams): Observable<Coverage[]> {
    const pathParams = {
      projectQuoteId: params.projectQuoteId,
      riskId: params.riskId,
    };
    const queryParams = {
      companyId: params.companyId,
      version: params.version,
    };

    return this.put<Coverage[], Coverage[]>({
      suffix: `/home/project/${pathParams.projectQuoteId}/risk/${pathParams.riskId}/coverages`,
      body,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
